/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2016 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
(function() {
	var fnft = {

		data: { },
		earlyKeyEventsProcessed: false,

		RWD_SMALL: 0,
		RWD_LARGE: 1,
		NUMBER_OF_ITEMS_ABOVE_FOLD: 12,
		LOG_PREFIX:						'CCX-FNFT :: ',
		CCXP_VULCAN_SPECIFIER:			'CCXP',
		VULCAN_STOCK_TEMPLATE_REQUEST:	'ccxprocess.StockTemplateRequest',
		VULCAN_STOCK_TEMPLATE_RESPONSE:	'ccxprocess.StockTemplateResponse',
		STOCK_RESPONSE_TIMEOUT:			1000, // 1 seconds
		StockTimeoutHandler:			null,

		/**
		 * Event handler for updating the calculation data from the host for AI/ID field calculations.
		 *
		 * @param evt 	event data object
		 */
		handleUpdateCalcData: function(evt) {
			var evtData = null;

			try {
				evtData = (typeof evt.data === 'string') ? JSON.parse(evt.data) : evt.data;
			}
			catch (err) {
				iaw.log.exception('Host calculation update handler exception: '+err.message);
			}
			if (evtData) {
				iaw.store.set(['host-calc-update'], evtData);
			}
		},

		/**
		 * Event handler for early key events that happened before the dialog initializes (iaw.cepUtil.events.EARLYKEYEVENTS)
		 * @param evt 	event data object
		 */
		handleEarlykeyEvents: function(evt) {
			iaw.cepUtil.csInterface.removeEventListener(iaw.cepUtil.events.EARLYKEYEVENTS, iaw.fnft.handleEarlykeyEvents);

			var evtData = null;

			try {
				evtData = (typeof evt.data === 'string') ? JSON.parse(evt.data) : evt.data;
			}
			catch (err) {
				iaw.log.exception('Host early key events handler exception: ' + err.message);
			}

			if (evtData && evtData.keyCodes.indexOf(iaw.a11y.Keys.ENTER) > -1) {
				iaw.fnft.createNewDocumentFromSelectedTemplate(false);
				iaw.fnft.closeExtOnStatus('true');
				return;
			}

			if (evtData && evtData.keyCodes.indexOf(iaw.a11y.Keys.ESC) > -1) {
				iaw.fnft.closeExtOnStatus('true');
				return;
			}

			// Tell the panel that we are done processing early key events
			iaw.fnft.earlyKeyEventsProcessed = true;
		},

		/**
		 * Generate a default data set if the Stock pull fails.
		 *
		 * @return an object representing the default data set.
		 */
		generateDefaultStockData: function(hostData) {
			var defaultData = {
				'nb_results': 0,
				'templates': [],
				'expirationDTS': '2015-11-01T00:00:00.000+00:00',
				'version': hostData.radarVersion || '0.0.0'
			};

			return defaultData;
		},

		/**
		 * Create the filter tab elements for the file new from template nav bar
		 *
		 * @param hostID			application host ID string
		 * @return An ordered array of the nav bar filter elements
		 */
		generateFilters: function(hostID) {
			var filters;
			switch (hostID) {
				case 'ILST':
					filters = [
						{type: 'recent',	name: 'newdoc_filter_recent'},
						{type: 'saved',     name: 'newdoc_filter_saved'},
						{type: 'mobile',	name: 'newdoc_filter_mobile'},
						{type: 'web',		name: 'newdoc_filter_web'},
						{type: 'print',		name: 'newdoc_filter_print'},
						{type: 'film',		name: 'newdoc_filter_film'},
						{type: 'art',		name: 'newdoc_filter_art'}
					];
					break;
				case 'PHXS':
					filters = [
						{type: 'recent',	name: 'newdoc_filter_recent'},
						{type: 'saved',     name: 'newdoc_filter_saved'},
						{type: 'photo',		name: 'newdoc_filter_photo'},
						{type: 'print',		name: 'newdoc_filter_print'},
						{type: 'art',		name: 'newdoc_filter_art'},
						{type: 'web',		name: 'newdoc_filter_web'},
						{type: 'mobile',	name: 'newdoc_filter_mobile'},
						{type: 'film',		name: 'newdoc_filter_film'}
					];
					break;
				case 'IDSN':
					filters = [
						{type: 'recent',	name: 'newdoc_filter_recent'},
						{type: 'saved',     name: 'newdoc_filter_saved'},
						{type: 'print',		name: 'newdoc_filter_print'},
						{type: 'web',		name: 'newdoc_filter_web'},
						{type: 'mobile',	name: 'newdoc_filter_mobile'}
					];
					break;
				default:
					filters = [
						{type: 'recent',	name: 'newdoc_filter_recent'},
						{type: 'saved',     name: 'newdoc_filter_saved'},
						{type: 'mobile',	name: 'newdoc_filter_mobile'},
						{type: 'web',		name: 'newdoc_filter_web'},
						{type: 'print',		name: 'newdoc_filter_print'},
						{type: 'photo',		name: 'newdoc_filter_photo'},
						{type: 'film',		name: 'newdoc_filter_film'},
						{type: 'art',		name: 'newdoc_filter_art'}
					];
					break;
			}
			return filters;
		},

		/**
		 * Get the icon font element associated with the corresponding ID.
		 *
		 * @param elementID	unique identifier string of the UI element
		 */
		getThumbnailIcon: function(elementID) {
			var iconMap = {
				'recent': 'SP_PresetNewFromPreset.png',
				'mobile': 'SP_PresetMobileAppDoc.png',
				'web': 'SP_PresetWebDoc.png',
				'print': 'SP_PrintDoc.png',
				'photo': 'SP_PresetPhotoDoc.png',
				'film': 'SP_PresetFilmVideo.png',
				'art': 'SP_PresetCustom.png'
			};
			var icon = iconMap[elementID] || 'CCX_Start_DefaultThumb_other.png';

			return 'images/thumbs/'+icon;
		},

		/**
		 * Get the JSON data block that matches the selected template.
		 *
		 * @param templateUUID	unique identifier string of the template
		 */
		getTemplateData: function(templateUUID) {

			var templateData  = null;

			if (templateUUID) {
				var dataIndex = iaw.store.get(['presetLUT', templateUUID]);

				if (dataIndex !== undefined ) {
					templateData = iaw.store.get('presets', dataIndex);
				}
				else {
					dataIndex = iaw.store.get(['templateLUT', templateUUID]);

					if (dataIndex !== undefined ) {
						templateData = iaw.store.get('templates', dataIndex);
					}
				}
			}
			return templateData;
		},

		/**
		 * Handle status coming back from the host ExtendScript method,
		 * closes the extension is status is 'true'. Remember callbacks/continuation
		 * methods from ExtendScript always send params as strings.
		 * For FNFT we have to close 2 extensions - the Start & FNFT.
		 *
		 * @param status       string containing 'false' if cancelled/error, 'true' otherwise
		 */
		closeExtOnStatus: function(status) {
			if ((status.toLowerCase() === 'true') && window.__adobe_cep__) {
				//iaw.analytics.ingest.logScreenStateEvent('close-auto');
				window.__adobe_cep__.closeExtension();
			}
		},

		/*
		 * Create a new Preset from the currently selected document settings
		 *
		 * @param name the name of the preset to create
		 * @return an object representing the created template set.
		 */
		createPreset: function(name, callback) {
			// get the selected template
			var templateData = iaw.fnft.getTemplateData(iaw.store.get(['input', 'selected-item']));
			if (!templateData) {
				try {
					templateData = JSON.parse(iaw.store.get('last-saved-template-data') || iaw.store.get('last-deleted-template-data'));
				}
				catch (e) {
					templateData = {isPreset: true};
				}
			}
			iaw.store.set('last-saved-template-data', JSON.stringify(templateData));

			var hostID  = iaw.store.get(['host', 'hostID']);
			var settings = iaw.store.get(['input', 'settings']);

			var tempObj = {};

			// merge templateData to tempObj
			iaw.util.assign(tempObj, templateData);

			if (templateData.isPreset && settings) {
				// merge custom settings to tempObj
				iaw.util.assign(tempObj, settings);
			}

			tempObj['template_category'] = 'saved';

			tempObj.title = name;
			tempObj.name = name;
			tempObj.group = 'user';

			if (hostID === 'PHXS') {
				if (templateData.isPreset) {
					if (window.__adobe_cep__) {
						iaw.cepUtil.evalExtendScriptWithParams('CCXWelcomeXSHost_PHXS.createPreset', tempObj, name, callback);
					}
					else {
						callback(tempObj);
					}
				}
			}
			else if (hostID === 'IDSN') {
				if (templateData.isPreset) {
					if (window.__adobe_cep__) {
						iaw.cepUtil.sendEvent( iaw.cepUtil.events.SAVEPRESET, tempObj);
						callback(tempObj);
					}
				}
			}

			return tempObj;
		},

		deletePreset: function(name) {
			if (!window.__adobe_cep__) return;
			var hostID  = iaw.store.get(['host', 'hostID']);
			var templateData = iaw.fnft.getTemplateData(iaw.store.get(['input', 'selected-item']));
			iaw.store.set('last-deleted-template-data', JSON.stringify(templateData));
			switch (hostID) {
				case 'PHXS':
					iaw.cepUtil.evalExtendScriptWithParams('CCXWelcomeXSHost_PHXS.deletePreset', name, iaw.fnft.closeExtOnStatus);
					break;
				case 'IDSN':
					iaw.cepUtil.sendEvent( iaw.cepUtil.events.DELETEPRESET, name);
					break;
			}
		},

		/*
		 * Create a new document from the currently selected template
		 *
		 * @param showDialog		boolean parameter indicating if the native document
		 *							dialog should be shown or not
		 */
		createNewDocumentFromSelectedTemplate: function(showDialog) {
			var self = this;
			// validate required parameter
			showDialog = showDialog || false;

			// get the selected template
			var templateData = iaw.fnft.getTemplateData(iaw.store.get(['input', 'selected-item']));

			if (templateData) {
				var hostID  = iaw.store.get(['host', 'hostID']);
				var docName = iaw.store.get(['input', 'doc-name']);
				var settings = iaw.store.get(['input', 'settings']);
				var tempObj = {};

				// set the document name for the new document
				tempObj.documentName = docName;
				tempObj.showDialog = showDialog;

				// merge templateData to tempObj
				iaw.util.assign(tempObj, templateData);

				if (templateData.isPreset && settings) {
					// merge custom settings to tempObj
					iaw.util.assign(tempObj, settings);
				}
				else if (!templateData.url) {
					var status = iaw.libraryManager.getTemplateStatus(templateData.id);
					if (status) {
						tempObj.url = status.path;
						tempObj.elementRef = status.elementRef;
					}
				}

				switch (hostID) {
					case 'PHXS':

						var fnftSettings = iaw.store.get(['host', 'fnftSettings']);
						if (fnftSettings.psSupportsDocCreationViaCEPEvents) {
							// New approach
							tempObj.pipMethod = iaw.util.getPipMethodString('stocktemplate', null);

							iaw.log.console(self.LOG_PREFIX + 'Sending data to create new doc: ' + JSON.stringify(tempObj));

							var psEventType = templateData.isPreset ? iaw.cepUtil.events.NEWDOCFROMTEMPLATE : iaw.cepUtil.events.PREVIEWDOCFROMTEMPLATE;
							iaw.cepUtil.sendEvent(psEventType, JSON.stringify(tempObj));
						}
						else {
							// LEGACY APPROACH - Keep until know will only ship w/ PS that has support for the above (probably PS 19.1)
							if (templateData.isPreset) {
								iaw.cepUtil.evalExtendScriptWithParams('CCXWelcomeXSHost_PHXS.createDocumentFromTemplate',
									tempObj, docName, showDialog, iaw.fnft.closeExtOnStatus);
							}
							else {
								var pipMethod = iaw.util.getPipMethodString('stocktemplate', null);
								window.__adobe_cep__.evalScript('CCXWelcomeXSHost_PHXS.openDocumentWithPath("'+tempObj.url+'","'+pipMethod+'",true,"'+templateData.elementRef+'")', iaw.fnft.closeExtOnStatus);
							}
						}
						break;

					default:
						iaw.log.console(self.LOG_PREFIX + 'Sending data to create new doc: ' + JSON.stringify(tempObj));
						var eventType = iaw.cepUtil.events.NEWDOCFROMTEMPLATE;

						if (settings.actionTrigger == 'preview') {
							eventType = iaw.cepUtil.events.PREVIEWDOCFROMTEMPLATE;
						}

						iaw.cepUtil.sendEvent(eventType, JSON.stringify(tempObj));
						break;
				}
			}
		},

		/**
		 * Get template data from the Adobe Stock service.
		 * @param hostData	host data passed from the application
		 * @param cb		callback method
		 */
		getStockData: function(hostData, cb) {
			if (!hostData.adobeGUID || hostData.adobeGUID.length === 0) {
				iaw.log.console(this.LOG_PREFIX + 'No user. Likely FRL or signed out.');
				// Offline or FRL case.
				cb(null, {});
			}
			var self = this;
			// var startTimestamp = Date.now();
			var onFinish = function(err, data) { //eslint-disable-line func-style
				if (err) {
					iaw.log.console(self.LOG_PREFIX + err);
				}
				// var durationInMilliSec = Date.now() - startTimestamp;

				// iaw.log.debug(self.LOG_PREFIX + 'It costs ' + durationInMilliSec + ' ms to get stock response from CCXProcess.');
				cb(data);
			};

			var uuid = iaw.util.generateGUID();
			var responder = {};
			responder.handler = function(msg) { //eslint-disable-line func-style
				var responseData = VulcanInterface.getPayload(msg);
				var stockJSON;
				var parsedData;

				// parse the JSON response
				try {
					parsedData = JSON.parse(responseData);
					// iaw.log.debug(self.LOG_PREFIX + 'Receiving ' + self.VULCAN_STOCK_TEMPLATE_RESPONSE + ' [' + parsedData.requestId + '], path is ' + parsedData.path);
				}
				catch (error) {
					// iaw.log.debug(self.LOG_PREFIX + 'Invalid JSON string:' + responseData);
					return;
				}
				// validate
				if (parsedData && parsedData.requestId === uuid) {
					// Clear timeout only if the response has the expected requestid.
					clearTimeout(self.StockTimeoutHandler);
					var err = null;

					if (parsedData.path) {
						// read in the locally written JSON data from Adobe Stock
						// and adjust image paths to the local file system
						stockJSON = iaw.json.readLocalJSONFile(parsedData.path);

						if (stockJSON && stockJSON.templates) {
							for (var i = 0; i < stockJSON.templates.length; i++) {
								var template = stockJSON.templates[i];
								var parentFolder = parsedData.path.substring(0, parsedData.path.lastIndexOf('/'));
								if (template['thumbnail_url'] ) {
									template['thumbnail_url'] = parentFolder && parentFolder + '/' + template['thumbnail_url'];
								}
								if (template.previews) {
									for (var j = 0; j < template.previews.length; j++) {
										var preview = template.previews[j];
										if (preview && preview.url) {
											preview.url = parentFolder && parentFolder + '/' + preview.url;
										}
									}
								}
							}
						}
					}
					else {
						err = 'path is missing, parsedData=' + JSON.stringify(parsedData);
					}
					// clear IPC listeners
					VulcanInterface.removeMessageListener(VulcanMessage.TYPE_PREFIX + self.VULCAN_STOCK_TEMPLATE_RESPONSE, responder.handler);
					// finish out
					onFinish(err, stockJSON);
				}
			};

			// Add message lisener for Stock response
			VulcanInterface.addMessageListener(VulcanMessage.TYPE_PREFIX + self.VULCAN_STOCK_TEMPLATE_RESPONSE, responder.handler);

			// Send Stock request
			var stockParams = {
				productCode:		hostData.hostID,
				productVersion:		hostData.appVersion,
				productLanguage:	hostData.language,
				countryCode:		hostData.countryCode,
				subscriptionStatus:	hostData.accountStatus,
				requestId:			uuid,
				featureFlag: 		false,
				release: 			'CCXStart-1-5'
			};

			if (stockParams.subscriptionStatus === 'trial') {
				stockParams.trialEndDTS = iaw.util.getTrialEndDate(hostData.secondsLeftInTrial);
			}

			var params = {
				stockParams:			stockParams,
				requestId:				uuid,
				userTrackingEnabled:	hostData.userTrackingEnabled
			};
			var StockRequestMsg = new VulcanMessage(VulcanMessage.TYPE_PREFIX + self.VULCAN_STOCK_TEMPLATE_REQUEST);

			StockRequestMsg.setPayload(JSON.stringify(params));
			VulcanInterface.dispatchMessage(StockRequestMsg);
			iaw.log.console(self.LOG_PREFIX + 'Sending ' + self.VULCAN_STOCK_TEMPLATE_REQUEST + ' [' + uuid + ']');
			var relaunched = false;
			// Set timeout
			function timeoutHandler() {
				// Check and launch CCXProcess
				if (!relaunched) {
					relaunched = true;
					iaw.util.launchCCXProcess();
					VulcanInterface.dispatchMessage(StockRequestMsg);
					self.StockTimeoutHandler = setTimeout(timeoutHandler, self.STOCK_RESPONSE_TIMEOUT);
					return;
				}

				VulcanInterface.removeMessageListener(VulcanMessage.TYPE_PREFIX + self.VULCAN_STOCK_TEMPLATE_RESPONSE, responder.handler);
				onFinish('It is timeout to get stock response from CCX Process.');
			}
			self.StockTimeoutHandler = setTimeout(timeoutHandler, self.STOCK_RESPONSE_TIMEOUT);
		}
	};

	window.iaw = window.iaw || {};
	window.iaw.fnft = fnft;
}());
